import { useState } from 'react';
import { patchApi, postApi } from 'views/services/api';
import { toast } from 'react-toastify';

// material-ui
import { useTheme } from '@mui/material/styles';
import { Box, Button, FormControl, FormHelperText, Grid, IconButton, InputAdornment, InputLabel, OutlinedInput } from '@mui/material';

// third party
import * as Yup from 'yup';
import { Formik } from 'formik';

// project imports
import AnimateButton from 'ui-component/extended/AnimateButton';


// ============================|| FIREBASE - LOGIN ||============================ //

const AuthForgetPassword = ({ ...others }) => {
  const theme = useTheme();

  return (
    <>
      <Grid container direction="column" justifyContent="center" spacing={2}>
        <Grid item xs={12} container alignItems="center" justifyContent="center"></Grid>
      </Grid>

      <Formik
        initialValues={{
          email: '',
        }}
        validationSchema={Yup.object().shape({
          email: Yup.string().email('Must be a valid email').max(255).required('Email is required'),
        })}
        // onSubmit={async (values,e) => {
        //   console.log("values for login  ==> ",values);

        //   try {
        //     const response = await postApi(values.email === 'admin@gmail.com' ? 'api/user/login' : 'api/hotel/login', values);
        //     console.log("response ===>",response);
        //     setUserData(response.data.user);
        //     console.log("userData after setUserData =====>", response.data.user);

        //     if(response.status === 200){
        //       toast.success('Logged In Successfully');
        //       localStorage.setItem('token', response.data.token);
        //       const role = response.data.user.role;

        //       if (role === 'admin') {
        //         localStorage.setItem('hotelData', JSON.stringify(response.data.user));
        //         window.location.replace('/dashboard/admindashboard');
        //       } else if (role === 'hotelAdmin') {
        //         localStorage.setItem('hotelData', JSON.stringify(response.data.user));
        //         window.location.replace('/dashboard/app');
        //       } else {
        //         localStorage.setItem('hotelData', JSON.stringify(response.data.user));
        //         window.location.replace('/dashboard/app');
        //       }
        //     }else if(response.status === 403){
        //       console.log("Not Approved yet, Please Contact Admin!!");
        //       toast.error('Not Approved yet, Please Contact Admin!!');
        //     }else{
        //       toast.error(response.response.data.error);
        //     }
        //   } catch (error) {
        //     toast.error(error.response.response.data.error);
        //   }
        // }}

        onSubmit={async (values, e) => {
          try {
            const response = await patchApi('api/hotel/forget-password', values);
            console.log('response ==>', response);

            if (response.status === 200) {
              toast.success("Password reset link has been sent to mail successfully");
              console.log(response);

            } else {
              toast.error(response.data.error);
            }
          } catch (error) {
            if (error.response) {
              toast.error(error.response.data.error || 'An error occurred');
            } else {
              toast.error('An unexpected error occurred');
            }
          }
        }}
      >
        {({ errors, handleBlur, handleChange, handleSubmit, touched, values }) => (
          <form noValidate onSubmit={handleSubmit} {...others}>
            <FormControl fullWidth error={Boolean(touched.email && errors.email)} sx={{ ...theme.typography.customInput }}>
              <InputLabel htmlFor="outlined-adornment-email-login">Email Address / Username</InputLabel>
              <OutlinedInput
                id="outlined-adornment-email-login"
                type="email"
                value={values.email}
                name="email"
                onBlur={handleBlur}
                onChange={handleChange}
                label="Email Address / Username"
                inputProps={{}}
              />
              {touched.email && errors.email && (
                <FormHelperText error id="standard-weight-helper-text-email-login">
                  {errors.email}
                </FormHelperText>
              )}
            </FormControl>

            {errors.submit && (
              <Box sx={{ mt: 3 }}>
                <FormHelperText error>{errors.submit}</FormHelperText>
              </Box>
            )}
            <Box sx={{ mt: 2 }}>
              <AnimateButton>
                <Button disableElevation fullWidth size="large" type="submit" variant="contained" color="secondary">
                  Submit
                </Button>
              </AnimateButton>
            </Box>
          </form>
        )}
      </Formik>
    </>
  );
};

export default AuthForgetPassword;
